import { useAuth } from 'auth/hooks/useAuth';
import { FormWithValidation } from 'shared/form';
import { LOGIN_ERROR_MESSAGES } from 'auth/constants/LoginErrorMessages';
import { Button, Grid } from '@orbita-ui/core';
import { PageTitle } from 'shared/components/Fonts';
import { Card } from 'shared/components';

export function ImpersonationPage() {
  const { loginAsUser } = useAuth();

  const searchCodigo = ({ username }) => {
    loginAsUser(username);
  };

  return (
    <Grid>
      <Grid.Item xs={4}>
        <PageTitle>Ingresar como otro usuario</PageTitle>
      </Grid.Item>
      <Grid.Item xs={4}>
        <Card>
          <Card.Title>Buscar usuario</Card.Title>
          <Card.Body $padding>
            <FormWithValidation onSubmit={searchCodigo}>
              <FormWithValidation.TextInput
                name="username"
                label="Nombre de usuario"
                placeholder="Ingrese el nombre del usuario"
                fullWidth
                registerOptions={{
                  required: LOGIN_ERROR_MESSAGES.codigoEmpty,
                }}
              />
              <div className="d-flex justify-content-end">
                <Button type="submit">Ingresar</Button>
              </div>
            </FormWithValidation>
          </Card.Body>
        </Card>
      </Grid.Item>
    </Grid>
  );
}
